import { render, staticRenderFns } from "./copygiftdataviewxg.vue?vue&type=template&id=01ff26e6&scoped=true&"
import script from "./copygiftdataviewxg.vue?vue&type=script&lang=js&"
export * from "./copygiftdataviewxg.vue?vue&type=script&lang=js&"
import style0 from "./copygiftdataviewxg.vue?vue&type=style&index=0&id=01ff26e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff26e6",
  null
  
)

export default component.exports